import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import {
  ViewIsCategoriesOfferingEnabledResult,
  viewIsCategoriesOfferingEnabled,
} from "../../../../projection/offering/viewIsCategoriesOfferingEnabled";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewIsCategoriesOfferingEnabledFunction {
  (): UseQueryFunctionResult<ViewIsCategoriesOfferingEnabledResult>;
}

const useViewIsCategoriesOfferingEnabled: UseViewIsCategoriesOfferingEnabledFunction = () =>
  useQuery({
    query: viewIsCategoriesOfferingEnabled(),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewIsCategoriesOfferingEnabled };
